// extracted by mini-css-extract-plugin
export default {"backdropOverlay":"backdropOverlay--dUwmX","light":"light--ARUuE"};